<template>
  <div>
    <div class="headerWrapper">
      <div class="top-left">
        <img class="logo" :src="leftMenuLogo" v-if="leftMenuLogo" />
        <p class="home-text">
          机构客户智能信息采集及见证开户系统
        </p>
        <div class="text" v-show="busiName && busiName.length > 0">
          {{ busiName }}
        </div>
        <p class="home-text" v-if="isTestEnv">
          <span class="color-r">{{ sysEnvTxt }}</span>
        </p>
      </div>
      <div class="top-right">
        <template v-if="userInfo">
          <!-- <img class="back-home headerImg" :src="backHome" @click="goHome" /> -->
          <Icon type="md-home" class="home-btn" size="18" color="#CFAA72" @click="goHome" v-if="isShowHome"/>
          <span class="line" v-if="isShowHome"></span>
          <span>{{userInfo.ORG_NAME}}</span>
          <span>{{userInfo.USER_CODE}}</span>
          <span>{{userInfo.USER_NAME}}</span>
          <span class="line"></span>
          <!-- <img class="logout headerImg" :src="logoutImg" @click="logout" />
           -->
          <Icon type="md-exit"  class="exit-btn" size="18" color="#CFAA72" @click="logout" />
        </template>
        <template v-else>
          <div class="head_right">
            <span>联系客服：95517</span>
          </div>
        </template>
      </div>
    </div>
    <!-- <select-account-type :visible.sync="isSelectAccountType" @close="closeSelectAccount" /> -->

  </div>
</template>

<script>
import { mapState } from "vuex";
import navStep from "./navStep.vue";
import baseConfig from "../../config/baseConfig";
import imageConfig from "../../config/imageConfig";
import dict from "../../tools/dict";
import org from "../../tools/org";
import date from "@/tools/date.js";
import oppService from "../../service/opp-service";
export default {
  data () {
    return {
      leftMenuLogo: imageConfig.$imgcfg[baseConfig.$basecfg.qsVersion].leftMenuLogo,
      backHome:require("@img/home/00home/icon_back.png"),
      // logoutImg:require("@img/home//01logined/icon_signout.png"),
      showCustomerInfo: false,
      ID_TYPE_LIST: {},
      customerInfoList: [],
      custInfo: {},
      sysEnvTxt: "", // 环境名称
    };
  },
  components: {
    navStep,
  },
  computed: {
    isLogin () {
      return this.$store.state.isLogin;
    },
    hasPassword () {
      return this.$store.state.hasPassword;
    },
    isExteral () { // 是否外部客户
      return this.$store.state.isExteral;
    },
    isShowLogoTitle () {
      // return ["businessList"].indexOf(this.$route.name) != -1 && !busiName;
      return true;
    },
    isLeftShow () {
      return !!this.leftOptions;
    },
    isRightShow () {
      return !!this.rightOptions;
    },
    isTestEnv () { // 是否显示测试环境标识
      return this.sysEnvTxt !== "生产环境";
    },
    userInfo () {
      return this.$store.state.userInfo || null;
    },
    isShowHome (){
      return !this.isHideHome;
    }
  },
  watch: {
    isLogin (val) {
      if (val) {
        this.initData();
      }
    },
    hasPassword (val) {
      if (val) {
        this.initData();
      }
    },
    userInfo (val){
      
      this.initData();
       
    }
  },
  props: {
    title: String,
    leftOptions: Object,
    rightOptions: Object,
    useNavStep: Boolean,
    busiName: String,
    isHideHome: Boolean,
  },
  methods: {
    beforeLogoutClick () {
      this.showCustomerInfo = !this.showCustomerInfo;
    },
    handleDocEvent () {
      this.showCustomerInfo = false;
    },
    async initData () {
      let that = this,
        custInfo = this.$storage.getJsonSession(that.$definecfg.CUSTOMER_INFO);
      this.sysEnvTxt = this.userInfo && await oppService.getSysCommonParamsFromCacheObjs("SYS_ENV_TEXT") || "";
    },
    // checkIsTestEnv () {
    //   let that = this;
    //   if (that.isTestEnv) {
    //     that.showTips({
    //       ownClass: "test-env-remind",
    //       tips: [`<div> 您好！当前系统为非生产环境，不能正常办理业务，请您在系统恢复后，前来办理业务，由此带来的不便敬请谅解。<p>国投证券</p><p>${date.formatDate(new Date(), "yyyy年MM月dd日")}</p></div>`],
    //       title: "尊敬的投资者",
    //       noPlayVoice: true,
    //       confirmedAction: function () {
    //         that.$store.commit(that.$types.UPDATE_BUSI_CODE, "");
    //         that.isSelectAccountType = true;
    //       },
    //     });
    //   } else {
    //     that.$store.commit(that.$types.UPDATE_BUSI_CODE, "");
    //     that.isSelectAccountType = true;
    //   }
    // },
    selectAccount () {
      this.checkIsTestEnv();
    },
    closeSelectAccount (val) {
      // this.isSelectAccountType = false;
    },
    goHome (){
      this.$router.replace({ path: "/home" });
    },
    logout (){
      this.confirm({
        title: "温馨提示：",
        messageText: "请确认是否退出当前账号？",
        confirmedAction: async () => {
          try{
            await vm.$syscfg.K_Request("F0000003",{});
          }catch (err){
            consoleError("退出登录失败");
          }
          this.$store.commit(this.$types.UPDATE_TOKEN, "");
          this.$store.commit(this.$types.UPDATE_USER_INFO, "");
          this.$router.push("/userLogin");
        }
      });
    
    },
  },
  created () {
    this.initData();
  },
  mounted () {
    document.addEventListener("click", this.handleDocEvent, false);
  },
  beforeDestroy () {
    document.removeEventListener("click", this.handleDocEvent, false);
  }
};
</script>

<style lang="less" scoped>
@import "~@/styles/less/variable.less";
.headerWrapper {
  flex: 0 0 80px;
  display: flex;
  height: 60px;
  width: 100%;
  justify-content: space-between;
  font-family: PingFangSC, PingFang SC;
  background: white;
  font-size: 28px;
  align-items: center;
  .top-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 59px;
    .logo {
      position: relative;
      height: 25px;
      width: 45px;
      margin: 0px 15px 0 60px;
    }
    .home-text {
      display: inline-flex;
      align-items: center;
      margin: 0;
      font-weight: 500;
    }
    .text {
      display: inline-flex;
      align-items: center;
      font-weight: 500;
      &::before {
        display: inline-block;
        content: "";
        margin: 0 32px 0 40px;
        width: 1px;
        height: 40px;
        background-color: #94adff;
      }
    }
  }
  .top-right {
    display: flex;
    position: relative;
    align-items: center;
    margin-right: 90px;
    font-size: 14px;
    &.headerImg {
      display: inline-block;
      width: 18px;
      height: 18px;
    }
    span{
      margin: 0 12px;
    }
    .line{
      display: block;
      width: 1px;
      height: 20px;
      background: #E8E8E8;
    }
    .home-btn,.exit-btn{
      cursor:pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/header.vue